import Destination from 'models/Destination';
import React from 'react';
import { useCallback, useRef } from 'react';
import { LightGallery as LightGalleryType } from 'lightgallery/lightgallery';
import { Fotografija } from 'kzv-icons';
import LightGallery from 'lightgallery/react';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lgShare from 'lightgallery/plugins/share';
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import Button from 'components/buttons/Button';
import { getPoiAreas } from '../../utils/POIHelpers';

import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-share.css';
import 'lightgallery/css/lg-fullscreen.css';

const DestinationGallery = ({ destination }: { destination: Destination }) => {
    const lightGallery = useRef<LightGalleryType | null>(null);

    const onPhotoClick = (index) => {
        if (isNaN(index)) index = 1;
        lightGallery?.current.openGallery(index);
    };

    const getGalleryItems = useCallback(() => {
        return destination.featured_photos.map((poiMedia) => {
            const { municipality, region } = getPoiAreas(poiMedia.poi);
            return {
                key: poiMedia.id,
                size: `${poiMedia.files.original.width}-${poiMedia.files.original.height}`,
                src: poiMedia.files.conversions.large.url,
                responsive: `${poiMedia.files.conversions.thumb.url} ${poiMedia.files.conversions.thumb.width}, ${poiMedia.files.conversions.medium.url} ${poiMedia.files.conversions.medium.width}, ${poiMedia.files.conversions.large.url} ${poiMedia.files.conversions.large.width}`,
                thumb: poiMedia.files.conversions.thumb.url,
                subHtml: `<a href='/ideja/${poiMedia.poi.slug}' class="mt-2 underline">${poiMedia.poi.name}</a> 
                <br /> 
                <small>${municipality.name}, ${region.name}</small>
                `,
                alt: poiMedia.media_type
            };
        });
    }, [destination.featured_photos]);

    const onInit = useCallback((detail) => {
        if (detail) {
            lightGallery.current = detail.instance;
        }
    }, []);

    const photoClasses = [
        'w-[66%] md:w-[31%]',
        'w-[33%] md:w-[16%]',
        'w-[98%] md:w-[36%]',
        'w-[29%] md:w-[16%]',
        'w-[69%] md:w-[44%]',
        'hidden md:block w-[108px] md:w-[16%]',
        'hidden md:block w-[108px] md:w-[39%]'
    ];

    return (
        <>
            <div className="relative">
                <div className="container p-0 cursor-pointer flex flex-row flex-wrap max-w-full overflow-hidden rounded-3xl gap-1">
                    {destination.featured_photos.map((image, i) => {
                        if (i < 6) {
                            return (
                                <img
                                    className={`${photoClasses[i]} h-[167px] md:h-[200px] grow object-cover`}
                                    key={image.id}
                                    src={image.files.conversions.medium.url}
                                    onClick={() => onPhotoClick(i)}
                                    alt=""
                                />
                            );
                        }
                    })}
                </div>
                <div className="absolute bottom-3 right-3 shadow-xl">
                    <Button
                        onClick={() => onPhotoClick(0)}
                        color="white"
                        variant="contained"
                        startIcon={<Fotografija />}
                    >
                        Razišči skozi fotografije
                    </Button>
                </div>
            </div>
            <LightGallery
                licenseKey="2852F19C-5E994C1D-B55C14A3-F04F3C90"
                plugins={[lgZoom, lgThumbnail, lgShare, lgFullscreen]}
                elementClassNames="custom-class-name"
                onInit={onInit}
                dynamic
                dynamicEl={getGalleryItems()}
                mobileSettings={{ showCloseIcon: true, fullScreen: false, download: false }}
            />
        </>
    );
};

export default DestinationGallery;
